// extracted by mini-css-extract-plugin
export default {"ClosedSampleListPage":"ClosedSampleListPage_ClosedSampleListPage__pULiM"};